module.exports = __webpack_public_path__ + "static/media/mostrarmas.ced1f222.svg";